// 📄 components/Configuracion/apiTiposConfig.ts
// Fuente única de metadata por sistema de API soportado (Ariba,
// S/4HANA Cloud, ...) — la usa el selector "¿Qué tipo de API vas a
// configurar?" y ApiDefinitionCard.tsx para decidir qué campos de
// credenciales mostrar. Agregar un sistema nuevo es agregar una entrada
// acá + su definición de campos en configService.js (backend), no tocar
// media docena de archivos. Mismo patrón que solucionesConfig.ts para
// las soluciones de Ariba.
import { ApiTipoId, ApiAuthTipo } from "../../services/clienteConexionService.ts";

export type { ApiAuthTipo };

export interface ApiTipoMeta {
  id: ApiTipoId;
  label: string;
  icon: string;
  descripcion: string;
  authTipo: ApiAuthTipo;
}

export const TIPOS_API: Record<ApiTipoId, ApiTipoMeta> = {
  ariba: {
    id: 'ariba',
    label: 'SAP Ariba',
    icon: '🔗',
    descripcion: 'APIs OpenAPI de Ariba Network (Supplier Data, Contract Workspaces, etc.), autenticadas con OAuth2 (API Key + OAuth Secret).',
    authTipo: 'oauth'
  },
  s4hana: {
    id: 's4hana',
    label: 'SAP S/4HANA Cloud',
    icon: '🏭',
    descripcion: 'APIs OData/REST expuestas por S/4HANA Cloud, autenticadas con usuario y contraseña.',
    authTipo: 'basic'
  }
};

export const TIPOS_API_LISTA: ApiTipoMeta[] = Object.values(TIPOS_API);

export const PROTOCOLOS_API = ['OData V2', 'OData V4', 'REST', 'SOAP'] as const;

export const AMBIENTES_API = ['Test', 'PRD'] as const;

export const METODOS_HTTP = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'] as const;
